// Configuración centralizada de estados y colores para badges
// Basado en la paleta de colores especificada

export const REQUEST_STATUS_CONFIG = {
  // Primary
  created: {
    backgroundColor: 'var(--rg-color-primary-lighter)',
    color: 'var(--rg-color-primary-active)',
    textColor: 'var(--rg-color-primary-active)',
    label: 'Creada',
    class: 'badge-custom-created'
  },
  
  // Warning
  pending_docs: {
    backgroundColor: 'var(--rg-color-warning-lighter)',
    color: 'var(--rg-color-warning-active)',
    textColor: 'var(--rg-color-warning-active)',
    label: 'Pendiente de Documentación',
    class: 'badge-custom-pending-docs'
  },
  pending_verification: {
    backgroundColor: 'var(--rg-color-warning-lighter)',
    color: 'var(--rg-color-warning-active)',
    textColor: 'var(--rg-color-warning-active)',
    label: 'Pendiente de Verificación',
    class: 'badge-custom-pending-verification'
  },
  observed: {
    backgroundColor: 'var(--rg-color-warning-lighter)',
    color: 'var(--rg-color-warning-active)',
    textColor: 'var(--rg-color-warning-active)',
    label: 'Observada',
    class: 'badge-custom-observed'
  },
  
  // Success
  verified: {
    backgroundColor: 'var(--rg-color-success-lighter)',
    color: 'var(--rg-color-success-active)',
    textColor: 'var(--rg-color-success-active)',
    label: 'Verificada',
    class: 'badge-custom-verified'
  },
  liquidated: {
    backgroundColor: 'var(--rg-color-success-lighter)',
    color: 'var(--rg-color-success-active)',
    textColor: 'var(--rg-color-success-active)',
    label: 'Liquidada',
    class: 'badge-custom-liquidated'
  },
  
  // Info
  paid: {
    backgroundColor: 'var(--rg-color-info-lighter)',
    color: 'var(--rg-color-info-active)',
    textColor: 'var(--rg-color-info-active)',
    label: 'Pagada',
    class: 'badge-custom-paid'
  },
  
  // Danger
  rejected: {
    backgroundColor: 'var(--rg-color-danger-lighter)',
    color: 'var(--rg-color-danger-active)',
    textColor: 'var(--rg-color-danger-active)',
    label: 'Rechazada',
    class: 'badge-custom-rejected'
  },
  
  // Secondary
  annulled: {
    backgroundColor: 'var(--rg-color-secondary-lighter)',
    color: 'var(--rg-color-secondary-active)',
    textColor: 'var(--rg-color-secondary-active)',
    label: 'Anulada',
    class: 'badge-custom-annulled'
  }
};

// Estados para cobros (mantener compatibilidad)
export const COLLECTION_STATUSES = {
  pending: { 
    label: 'Pendiente', 
    class: 'badge-custom-pending',
    backgroundColor: 'var(--rg-color-warning-lighter)',
    textColor: 'var(--rg-color-warning-active)'
  },
  processed: { 
    label: 'Procesado', 
    class: 'badge-custom-processed',
    backgroundColor: 'var(--rg-color-success-lighter)',
    textColor: 'var(--rg-color-success-active)'
  },
  rejected: { 
    label: 'Rechazado', 
    class: 'badge-custom-rejected',
    backgroundColor: 'var(--rg-color-danger-lighter)',
    textColor: 'var(--rg-color-danger-active)'
  }
};

// Función helper para obtener la clase CSS de un estado
export const getStatusBadgeClass = (status, statusType = 'request') => {
  const statusConfig = statusType === 'collection' ? COLLECTION_STATUSES : REQUEST_STATUS_CONFIG;
  return statusConfig[status]?.class || 'badge-custom-default';
};

// Función helper para obtener el label de un estado
export const getStatusLabel = (status, statusType = 'request') => {
  const statusConfig = statusType === 'collection' ? COLLECTION_STATUSES : REQUEST_STATUS_CONFIG;
  return statusConfig[status]?.label || status;
};

// Función helper para obtener los colores de un estado
export const getStatusColors = (status, statusType = 'request') => {
  const statusConfig = statusType === 'collection' ? COLLECTION_STATUSES : REQUEST_STATUS_CONFIG;
  return statusConfig[status] || {
    backgroundColor: 'var(--rg-color-secondary-lighter)',
    textColor: 'var(--rg-color-secondary-active)'
  };
};
